<template>
  <Modal :click_outside="false" @close="$emit('close')" classes="w-auto lg:w-125 bg-white px-4 lg:px-12 pb-8">
    <div v-if="!sent">
      <h1 v-if="questionNumber" class="text-main-text text-lg font-bold text-center">Обратная связь по вопросу
        <span class="text-brand-light hidden md:inline">№ {{questionNumber}} </span>
        <span class="text-brand-light hidden md:inline">(тур {{tourNumber}}{{displayedTour ? `(${displayedTour})` : ''}})</span>
      </h1>
      <p v-if="questionNumber"  class="md:hidden text-center text-main-text text-lg font-bold mt-1">
        <span class="text-brand-light">№ {{questionNumber}} </span>
        <span class="text-brand-light">(тур {{tourNumber}}{{displayedTour ? `(${displayedTour})` : ''}})</span>
      </p>
      <h1 v-else class="text-main-text text-lg font-bold text-center">
        Обратная связь по туру
        <span class="text-brand-light">(тур {{tourNumber}}{{displayedTour ? `(${displayedTour})` : ''}})</span>
      </h1>
      <p class="text-sm leading-tight text-center my-5 hidden md:block">Мы будем рады подробной обратной связи — это<br> поможет нам делать игры лучше и интереснее :)</p>
      <p class="text-sm leading-tight text-center my-5 md:hidden">Мы будем рады подробной обратной<br>  связи — это поможет нам делать игры<br>  лучше и интереснее :)</p>
      <form @submit.prevent="sendFeedback">
        <div>
          <textarea class="rounded border border-additional-text w-full text-base  p-4 mt-3"
                    v-model="form.comment" style="outline: none; resize: none;" rows="9" :placeholder="'Описать подробнее'"></textarea>
        </div>
         <div class="w-full flex justify-center mt-5">
           <button class="text-white text-sm leading-none text-center py-3 px-8 rounded-full outline-none"
                :class="[isButtonDisable? 'bg-#dadada cursor-default':'bg-brand-light hover-up']"
                :disabled="isButtonDisable">
             Отправить
           </button>
         </div>
      </form>
    </div>
    <div v-else>
      <h1 class="text-main-text text-lg font-bold text-center">
        Данные успешно отправлены!
      </h1>
      <p class="mt-5 text-main-text text-lg text-center">
        Мы пришлём ответ на вашу корпоративную почту
      </p>
      <p class="mt-1 text-brand-light text-lg text-center font-bold">
        {{user.email}}
      </p>
    </div>

  </Modal>
</template>
<script>
import Modal from '@/views/modals/new-base-modal.vue';
import Form from 'form-backend-validation';
import client from '@/clients/partners';
import { mapState } from 'vuex';

export default {
  name: 'questionTourFeedbackModal',
  props: ['tourNumber', 'questionNumber', 'questionId', 'gameId', 'eventRecordId', 'displayedTour'],
  components: {
    Modal,
  },
  data() {
    return {
      form: new Form({
        comment: null,
        reason: null,
        user_id: null,
        tour_id: null,
        question_id: null,
        question_number: null,
        game_id: null,
        displayed_tour_number: null,
      }, {
        http: client,
      }),
      sent: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    isButtonDisable() {
      return !this.form.comment;
    },
  },
  methods: {
    sendFeedback() {
      if (this.isButtonDisable) return;
      this.form.game_id = this.gameId;
      this.form.user_id = this.user.id;
      this.form.tour_id = this.tourNumber;
      this.form.displayed_tour_number = this.displayedTour;
      this.form.question_number = this.questionNumber;
      this.form.question_id = this.questionId;
      this.form.reason = null;
      this.form.post(`/callback/${this.eventRecordId}/send`).then(() => {
        this.sent = true;
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>

</style>
